export default function Badge({ label, color = "#1a6b45" }) {
  return (
    <span
      style={{
        background: color + "15",
        color,
        border: `1px solid ${color}30`,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: "0.08em",
        padding: "2px 8px",
        borderRadius: 20,
        textTransform: "uppercase",
      }}
    >
      {label}
    </span>
  );
}
